<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19HGokm/tc-custom/9781398481794.jpg?1705539782458" alt="This image is the cover for the book Word Worries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Word Worries
      </h1>
      <p class="bookDescription body article font2">
        <p>The Feel Good Fairy visits Milly to calm her thoughts and help her sleep. Milly has been really worried about her learning at school, she was so scared every time she had to read or write in class. She thought she was slow and not as clever as the other children. Each night she just tossed and turned, not knowing what the next day would bring and what she would be asked to do. Then one day she was given some magical keys which were special positions or poses for her to put her body in. If she did these poses each day they would unlock four boxes in her brain called: Anxiety, Focus, Confidence and Memory. These were all things that were either happening too much or too little for Milly. By following the wisdom of the Feel Good Fairy, Milly gets to access her own superpowers and feel good again!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tracy King
      </h2>
      
      <p class="authorDescription body article">Dr Tracy King is a Clinical Psychologist, Hypnotherapist, Life Coach and Yoga and Meditation Teacher who works with children and adults to help them reach their potential in life. She sees children involved in care proceedings who have experienced early life traumas and losses and has seen the value of yoga in helping gain a sense of balance in their unstable worlds. She personally experienced the importance of mindset and present focus in her own challenge ascending Mount Kilimanjaro in Tanzania with a temperature of -22 during her summit climb. She has three daughters and aside from yoga she enjoys horse riding, hiking, travelling and photography.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6b9927a0